/* Attention: this file is auto-generated */
/* Run: yarn scripts:js-variables to generate this file */
module.exports = {
  borderRadius500: '2px',
  borderRadius600: '3px',
  borderStyle500: '1px solid',
  borderStyle600: '2px solid',
  borderStyle700: '4px solid',
  borderWidth500: '1px',
  borderWidth600: '2px',
  borderWidth700: '4px',
  breakpointDesktop: '(min-width: 1113px)',
  mediaDesktop: '(min-width: 1113px)',
  breakpointDesktopRange: '(min-width: 1113px) and (max-width: 1258px)',
  mediaDesktopRange: '(min-width: 1113px) and (max-width: 1258px)',
  breakpointDesktopWide: '(min-width: 1024px)',
  mediaDesktopWide: '(min-width: 1024px)',
  breakpointDesktopWideRange: '(min-width: 1024px) and (max-width: 1239px)',
  mediaDesktopWideRange: '(min-width: 1024px) and (max-width: 1239px)',
  breakpointDesktopXlWide: '(min-width: 1240px)',
  mediaDesktopXlWide: '(min-width: 1240px)',
  breakpointHandheld: '(max-width: 739px)',
  mediaHandheld: '(max-width: 739px)',
  breakpointHandheldRange: '(min-width: 0px) and (max-width: 739px)',
  mediaHandheldRange: '(min-width: 0px) and (max-width: 739px)',
  breakpointNav: '(min-width: 1259px)',
  mediaNav: '(min-width: 1259px)',
  breakpointNavRange: '(min-width: 1259px)',
  mediaNavRange: '(min-width: 1259px)',
  breakpointTablet: '(min-width: 740px)',
  mediaTablet: '(min-width: 740px)',
  breakpointTabletRange: '(min-width: 740px) and (max-width: 1112px)',
  mediaTabletRange: '(min-width: 740px) and (max-width: 1112px)',
  breakpointTabletWideRange: '(min-width: 740px) and (max-width: 1023px)',
  mediaTabletWideRange: '(min-width: 740px) and (max-width: 1023px)',
  colorBackground: 'rgb(255, 255, 255)',
  colorBackgroundAside: 'rgb(245, 245, 245)',
  colorBackgroundBeta: 'rgb(226, 0, 122)',
  colorBackgroundBrandedDark: 'rgb(0, 117, 117)',
  colorBackgroundBrandedLight: 'rgb(176, 212, 0)',
  colorBackgroundErrorDark: 'rgb(243, 58, 88)',
  colorBackgroundErrorLight: 'rgb(253, 235, 238)',
  colorBackgroundFeedback: 'rgb(226, 0, 122)',
  colorBackgroundInteractive: 'rgb(0, 144, 144)',
  colorBackgroundPage: 'rgb(235, 235, 235)',
  colorBackgroundPromo: 'rgb(104, 195, 252)',
  colorBackgroundSuccessDark: 'rgb(77, 184, 107)',
  colorBorder: 'rgb(229, 229, 229)',
  colorBorderActive: 'rgb(0, 144, 144)',
  colorBorderError: 'rgb(243, 58, 88)',
  colorBorderField: 'rgb(179, 179, 179)',
  colorBorderStrong: 'rgb(204, 204, 204)',
  colorBorderSuccess: 'rgb(77, 184, 107)',
  colorCopy: 'rgb(51, 51, 51)',
  colorCopyError: 'rgb(243, 58, 88)',
  colorCopyInverted: 'rgba(255, 255, 255, 0.75)',
  colorCopyInvertedStrong: 'rgb(255, 255, 255)',
  colorCopyLink: 'rgb(0, 144, 144)',
  colorCopyLinkHover: 'rgb(0, 117, 117)',
  colorCopyLinkVisited: 'rgb(114, 136, 149)',
  colorCopySoft: 'rgb(102, 102, 102)',
  colorCopySuccess: 'rgb(77, 184, 107)',
  colorCopyWeak: 'rgb(128, 128, 128)',
  colorError: 'rgb(243, 58, 88)',
  colorNotification: 'rgb(255, 160, 0)',
  colorPreload: 'rgb(179, 179, 179)',
  colorPreloadLight: 'rgb(235, 235, 235)',
  colorPremiumMintDark: 'rgb(25, 153, 128)',
  colorPremiumMintLight: 'rgb(0, 210, 150)',
  colorSuccess: 'rgb(77, 184, 107)',
  colorTrafficGreen: 'rgb(77, 184, 107)',
  colorTrafficRed: 'rgb(243, 58, 88)',
  colorTrafficYellow: 'rgb(255, 160, 0)',
  colorUserBasic: 'rgb(153, 153, 153)',
  colorUserExecutive: 'rgb(51, 51, 51)',
  effectStandard: 'cubic-bezier(.4,0,.2,1)',
  effectEnter: 'cubic-bezier(0,.2,.2,1)',
  effectLeave: 'cubic-bezier(.4,0,1,1)',
  effectArc: 'cubic-bezier(0.1, 1.4, 0.6, 1.1)',
  effect: 'cubic-bezier(.2,.2,.2,1)',
  fontDisplay1LineHeight: '28px',
  fontDisplay1Size: '22px',
  fontDisplay2LineHeight: '32px',
  fontDisplay2Size: '26px',
  fontDisplay3LineHeight: '40px',
  fontDisplay3Size: '32px',
  fontDisplay4LineHeight: '48px',
  fontDisplay4Size: '40px',
  fontDisplay5LineHeight: '56px',
  fontDisplay5Size: '48px',
  fontDisplay6LineHeight: '64px',
  fontDisplay6Size: '52px',
  fontLargeLineHeight: '24px',
  fontLargeSize: '18px',
  fontMediumLineHeight: '24px',
  fontMediumSize: '16px',
  fontMiniLineHeight: '16px',
  fontMiniSize: '12px',
  fontNormalLineHeight: '20px',
  fontNormalSize: '14px',
  fontSize1000: '52px',
  fontSize100: '12px',
  fontSize200: '14px',
  fontSize300: '16px',
  fontSize400: '18px',
  fontSize500: '22px',
  fontSize600: '26px',
  fontSize700: '32px',
  fontSize800: '40px',
  fontSize900: '48px',
  fontWeightBold: '700',
  fontWeightNormal: '400',
  gradientPremium:
    'linear-gradient(to top, #007575 0%, #199980 50%, #00D296 100%)',
  gradientPremiumRadialGradient:
    'radial-gradient(circle at 83% -40px, #00D296, #199980 50%, #007575)',
  gradientSecondary: 'linear-gradient(to bottom, #D9D9D9 0, #CCCCCC 100%)',
  gradientUserPremium:
    'linear-gradient(to bottom, #9ccb5d, #80c189 25%, #47abdd)',
  gridBase: '4',
  lineHeight100: '16px',
  lineHeight200: '20px',
  lineHeight300: '24px',
  lineHeight400: '28px',
  lineHeight500: '32px',
  lineHeight600: '40px',
  lineHeight700: '48px',
  lineHeight800: '56px',
  lineHeight900: '64px',
  maxWidthDesktop: '1258px',
  maxWidthDesktopWide: '1239px',
  maxWidthHandheld: '739px',
  maxWidthTablet: '1112px',
  maxWidthTabletWide: '1023px',
  minWidthDesktop: '1113px',
  minWidthDesktopWide: '1024px',
  minWidthDesktopXlWide: '1240px',
  minWidthNav: '1259px',
  minWidthTablet: '740px',
  paletteBerry500: 'rgb(156, 25, 91)',
  paletteBlue100: 'rgb(239, 249, 254)',
  paletteBlue500: 'rgb(104, 195, 252)',
  paletteGrass500: 'rgb(77, 184, 107)',
  paletteGrey040: 'rgb(245, 245, 245)',
  paletteGrey050: 'rgb(242, 242, 242)',
  paletteGrey080: 'rgb(235, 235, 235)',
  paletteGrey100: 'rgb(229, 229, 229)',
  paletteGrey150: 'rgb(217, 217, 217)',
  paletteGrey200: 'rgb(204, 204, 204)',
  paletteGrey300: 'rgb(179, 179, 179)',
  paletteGrey400: 'rgb(153, 153, 153)',
  paletteGrey500: 'rgb(128, 128, 128)',
  paletteGrey600: 'rgb(102, 102, 102)',
  paletteGrey700: 'rgb(77, 77, 77)',
  paletteGrey800: 'rgb(51, 51, 51)',
  paletteLime500: 'rgb(176, 212, 0)',
  paletteMagenta500: 'rgb(226, 0, 122)',
  paletteMint300: 'rgb(0, 210, 150)',
  paletteMint500: 'rgb(25, 153, 128)',
  paletteOrange500: 'rgb(255, 160, 0)',
  palettePetrol100: 'rgb(191, 220, 220)',
  palettePetrol200: 'rgb(127, 186, 186)',
  palettePetrol300: 'rgb(0, 144, 144)',
  palettePetrol500: 'rgb(0, 117, 117)',
  palettePigeon080: 'rgb(242, 247, 249)',
  palettePigeon100: 'rgb(222, 234, 239)',
  palettePigeon200: 'rgb(164, 178, 187)',
  palettePigeon300: 'rgb(114, 136, 149)',
  palettePigeon500: 'rgb(87, 112, 128)',
  palettePigeon700: 'rgb(54, 85, 104)',
  paletteRed100: 'rgb(253, 235, 238)',
  paletteRed500: 'rgb(243, 58, 88)',
  paletteWhite: 'rgb(255, 255, 255)',
  shadow200: '0 1px 1px 0 rgba(0, 0, 0, 0.3)',
  shadow500: '0 1px 5px 0 rgba(0, 0, 0, 0.3)',
  shadow700: '0 2px 8px 0 rgba(0, 0, 0, 0.5)',
  space10: '40px',
  space12: '48px',
  space14: '56px',
  space16: '64px',
  space1: '4px',
  space20: '80px',
  space24: '96px',
  space28: '112px',
  space2: '8px',
  space3: '12px',
  space4: '16px',
  space5: '20px',
  space6: '24px',
  space8: '32px',
  spacingInlineL: '0 24px 0 0',
  spacingInlineM: '0 12px 0 0',
  spacingInlineS: '0 8px 0 0',
  spacingInlineXl: '0 32px 0 0',
  spacingInlineXs: '0 4px 0 0',
  spacingInlineXxl: '0 56px 0 0',
  spacingInlineXxxl: '0 96px 0 0',
  spacingInsetL: '24px',
  spacingInsetM: '12px',
  spacingInsetS: '8px',
  spacingInsetSquishL: '8px 24px',
  spacingInsetSquishM: '4px 12px',
  spacingInsetSquishS: '4px 8px',
  spacingInsetSquishXl: '12px 32px',
  spacingInsetSquishXs: '0 4px',
  spacingInsetSquishXxl: '24px 56px',
  spacingInsetSquishXxxl: '32px 96px',
  spacingInsetStretchL: '24px 12px',
  spacingInsetStretchM: '12px 8px',
  spacingInsetStretchS: '8px 4px',
  spacingInsetStretchXl: '32px 24px',
  spacingInsetStretchXs: '4px 0',
  spacingInsetStretchXxl: '32px 56px',
  spacingInsetStretchXxxl: '56px 96px',
  spacingInsetXl: '32px',
  spacingInsetXs: '4px',
  spacingInsetXxl: '56px',
  spacingInsetXxxl: '96px',
  spacingStackL: '0 0 24px 0',
  spacingStackM: '0 0 12px 0',
  spacingStackS: '0 0 8px 0',
  spacingStackXl: '0 0 32px 0',
  spacingStackXs: '0 0 4px 0',
  spacingStackXxl: '0 0 56px 0',
  spacingStackXxxl: '0 0 96px 0',
  speedFast: '150ms',
  speedInstant: '50ms',
  speedMedium: '250ms',
  transition: '150ms cubic-bezier(.2,.2,.2,1)',
  zindex0: '-1',
  zindex100: '0',
  zindex200: '3',
  zindex300: '6',
  zindex400: '9',
  zindex500: '12',
  zindex600: '15',
  zindex700: '18',
  zindex800: '21',
  zindex900: '24',
};
